var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup9116(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 17.8856L38.3531 17.8684C38.2297 17.876 38.1064 17.8891 37.9916 17.9063C37.9002 17.9184 37.8094 17.9346 37.719 17.9528C37.4422 18.0072 37.1704 18.0848 36.9067 18.1847C36.2085 18.4468 35.5769 18.8587 35.0567 19.3912C35.043 19.4953 35.0318 19.6009 35.0222 19.7065C34.9327 20.66 34.9809 21.6214 35.1654 22.5612C35.3334 23.6096 35.7347 24.6074 36.34 25.4816C36.9453 26.3558 37.7392 27.0843 38.6638 27.6138H38.6836L38.807 27.5759C37.5118 26.3246 36.7419 24.6309 36.6526 22.8367C36.5634 21.0424 37.1615 19.2813 38.3262 17.9088C38.3265 17.9006 38.3289 17.8925 38.3333 17.8856Z",
    fill: "url(#paint0_linear_1905_990)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1052 15.2567C32.0844 15.4148 32.0656 15.5745 32.0508 15.7342C31.8128 18.2325 32.3026 20.7463 33.4617 22.975C33.4972 23.0448 33.5358 23.1125 33.5729 23.1812C33.67 23.3611 33.7715 23.5382 33.8775 23.7127C34.8691 25.367 36.2169 26.782 37.8237 27.8559C37.8592 27.8806 37.8927 27.9064 37.9283 27.9281L37.9689 27.9529L37.9826 27.9392L38.0258 27.8973C38.0506 27.8766 38.0765 27.8579 38.1009 27.8397C38.2145 27.7728 38.3363 27.7208 38.4634 27.6851C35.9427 26.1339 35.1832 24.3382 34.834 22.5511C34.6846 21.7833 34.625 21.0008 34.6563 20.2194C34.6563 20.0895 34.6685 19.9591 34.6796 19.8303C34.79 18.4818 35.1724 17.1694 35.804 15.9713C36.4357 14.7733 37.3035 13.7143 38.3557 12.8577C38.2979 12.8516 38.2324 12.8481 38.1806 12.8441C38.0633 12.8355 37.9476 12.8279 37.8303 12.8259C37.2885 12.8127 36.7469 12.8579 36.2149 12.9608C34.6308 13.2617 33.1883 14.0676 32.1052 15.2567Z",
    fill: "url(#paint1_linear_1905_990)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5506 22.5666C30.7716 22.8941 31.0063 23.2119 31.2548 23.5201L31.4005 23.7004C32.7416 25.3393 34.4071 26.6862 36.2935 27.6571L36.4499 27.737C36.8699 27.9465 37.2974 28.1366 37.7323 28.3074C37.7531 28.2596 37.7765 28.2128 37.8023 28.1675L37.779 28.1528C37.716 28.1134 37.6556 28.0745 37.5901 28.03C37.484 27.9613 37.3794 27.8891 37.2759 27.8178H37.2683C36.0482 26.9703 34.9819 25.9225 34.115 24.7191C33.9627 24.5079 33.8181 24.2896 33.6759 24.0673C33.4728 23.7459 33.2814 23.4145 33.1022 23.0709C32.0176 20.98 31.5204 18.6365 31.6629 16.2878C31.6751 16.1023 31.6888 15.9194 31.7071 15.732C31.9337 13.5402 32.7083 11.4397 33.9602 9.62238C33.7358 9.66482 33.5123 9.71534 33.2896 9.77395C31.1167 10.3476 29.2085 11.6483 27.8858 13.4573C27.7886 16.6973 28.7217 19.8851 30.5521 22.5661L30.5506 22.5666Z",
    fill: "url(#paint2_linear_1905_990)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.411 25.1619C31.7286 26.9956 34.4702 28.2232 37.3862 28.7331L37.5944 28.7665L37.6091 28.6927C37.6152 28.6695 37.6203 28.6462 37.6263 28.623C35.2301 27.7389 33.0917 26.277 31.4027 24.3682C31.2673 24.2183 31.1361 24.0649 31.0092 23.9079C29.2305 21.7393 28.0749 19.1318 27.6651 16.3623C27.2554 13.5927 27.6068 10.7644 28.682 8.17761C28.4353 8.28069 28.1887 8.39319 27.9423 8.51513C25.5376 9.72796 23.635 11.7399 22.5645 14.2023C23.1795 17.2866 24.5832 20.1609 26.6401 22.5477C27.471 23.5116 28.3995 24.3877 29.411 25.1619Z",
    fill: "url(#paint3_linear_1905_990)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5411 26.3627C25.313 26.8574 26.1172 27.3001 26.9485 27.688C30.0807 29.1544 33.5409 29.7887 36.9925 29.5292C37.1849 29.5145 37.3773 29.4958 37.5697 29.4786C37.5697 29.4236 37.5636 29.368 37.5601 29.3129V29.1057C37.1096 29.0384 36.6608 28.9565 36.2137 28.8602C33.5994 28.2789 31.1449 27.1344 29.0229 25.5073C28.449 25.0691 27.9013 24.5979 27.3826 24.0961C24.821 21.6171 23.0422 18.4478 22.2646 14.9771C21.7473 12.6862 21.6745 10.3181 22.0499 8C21.792 8.18644 21.5392 8.38299 21.294 8.58913C18.8502 10.6349 17.2043 13.4685 16.6426 16.597C18.1508 20.6134 20.9208 24.0383 24.5411 26.3627Z",
    fill: "url(#paint4_linear_1905_990)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0179 31.1313C25.4865 31.4424 26.9839 31.5987 28.4855 31.5977C31.2746 31.6011 34.0368 31.0538 36.6119 29.9874C36.0751 30.0268 35.5366 30.0437 34.9965 30.038C32.0964 30.0169 29.2355 29.3699 26.6111 28.1417L26.4532 28.0654C21.9347 25.918 18.3864 22.1664 16.5057 17.5479C15.6703 15.4992 15.1791 13.3278 15.0517 11.1205V11.0947C14.8197 11.3549 14.5948 11.6222 14.3831 11.8996C13.173 13.4677 12.2898 15.2605 11.7852 17.1729C11.2806 19.0852 11.1648 21.0786 11.4446 23.0361C14.4976 27.1764 18.9718 30.0571 24.0179 31.1313Z",
    fill: "url(#paint5_linear_1905_990)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4876 32.3387C38.1733 32.3387 37.9672 32.1336 37.8708 31.7324C37.7733 31.3054 37.7103 30.8633 37.6621 30.4879C37.66 30.4496 37.6554 30.4115 37.6484 30.3737L37.6337 30.2424L37.6154 30.0681L37.6042 29.9574C34.7048 31.3742 31.5168 32.1088 28.2867 32.1043C27.6183 32.1043 26.9583 32.0739 26.3068 32.0133C20.9844 31.5158 16.0488 29.0309 12.4928 25.0584C12.1882 24.7172 11.8962 24.3662 11.617 24.0054C11.6175 24.0108 11.6175 24.0162 11.617 24.0216C10.8689 23.0725 10.2043 22.0611 9.63047 20.9986C9.52588 21.3483 9.44567 21.7156 9.36647 22.0738C8.54349 25.7918 9.11739 29.681 10.9797 33.0065C12.8421 36.332 15.8638 38.8634 19.474 40.1224C23.0841 41.3814 27.0326 41.2807 30.5733 39.8393C34.1139 38.398 37.0014 35.7159 38.6902 32.2998C38.6261 32.3223 38.5586 32.3339 38.4906 32.3341L38.4876 32.3387Z",
    fill: "url(#paint6_linear_1905_990)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4031 35.0947C33.386 35.0949 32.3916 34.7949 31.5459 34.2327C30.7001 33.6704 30.0408 32.8712 29.6514 31.936C29.2621 31.0008 29.1601 29.9718 29.3585 28.9789C29.5568 27.9861 30.0466 27.0741 30.7657 26.3583C31.4849 25.6425 32.4012 25.155 33.3988 24.9575C34.3964 24.76 35.4304 24.8614 36.3701 25.2488C37.3097 25.6362 38.1129 26.2922 38.6779 27.1339C39.243 27.9756 39.5445 28.9652 39.5444 29.9774C39.5441 31.3344 39.0024 32.6358 38.0383 33.5954C37.0742 34.555 35.7666 35.0943 34.4031 35.0947Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4049 34.6599C37.0038 34.6599 39.1106 32.5631 39.1106 29.9766C39.1106 27.3901 37.0038 25.2933 34.4049 25.2933C31.806 25.2933 29.6992 27.3901 29.6992 29.9766C29.6992 32.5631 31.806 34.6599 34.4049 34.6599Z",
    fill: "#901F5D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9752 29.6507L33.6296 27.1112C33.5679 27.0644 33.4942 27.0356 33.417 27.0281C33.3397 27.0207 33.2619 27.0349 33.1923 27.0691C33.1227 27.1032 33.0641 27.1561 33.023 27.2217C32.982 27.2872 32.9601 27.3629 32.96 27.4402V32.5201C32.9601 32.5973 32.982 32.673 33.023 32.7386C33.0641 32.8041 33.1227 32.857 33.1923 32.8912C33.2619 32.9254 33.3397 32.9395 33.417 32.9321C33.4942 32.9246 33.5679 32.8958 33.6296 32.849L36.9752 30.3095C37.0257 30.2708 37.0665 30.221 37.0947 30.1641C37.1228 30.1072 37.1374 30.0446 37.1374 29.9811C37.1374 29.9177 37.1228 29.8551 37.0947 29.7982C37.0665 29.7412 37.0257 29.6915 36.9752 29.6527V29.6507Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#EE4352",
    fillOpacity: 0.969
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1905_990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 34C41.6155 34 40.2622 34.4105 39.111 35.1797C37.9599 35.9489 37.0627 37.0421 36.5328 38.3212C36.003 39.6003 35.8644 41.0078 36.1345 42.3656C36.4046 43.7235 37.0713 44.9708 38.0503 45.9497C39.0292 46.9287 40.2765 47.5954 41.6344 47.8655C42.9922 48.1356 44.3997 47.997 45.6788 47.4672C46.9579 46.9373 48.0511 46.0401 48.8203 44.889C49.5895 43.7378 50 42.3845 50 41C49.998 39.1441 49.2599 37.3648 47.9475 36.0525C46.6352 34.7401 44.8559 34.002 43 34V34ZM43 46.8333C41.8463 46.8333 40.7185 46.4912 39.7592 45.8502C38.7999 45.2093 38.0522 44.2982 37.6107 43.2323C37.1692 42.1664 37.0537 40.9935 37.2788 39.862C37.5038 38.7304 38.0594 37.691 38.8752 36.8752C39.691 36.0594 40.7304 35.5038 41.862 35.2788C42.9935 35.0537 44.1664 35.1692 45.2323 35.6107C46.2982 36.0522 47.2093 36.7999 47.8502 37.7592C48.4912 38.7185 48.8333 39.8463 48.8333 41C48.8316 42.5466 48.2165 44.0293 47.1229 45.1229C46.0293 46.2165 44.5466 46.8316 43 46.8333V46.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0003 36.9167C42.8456 36.9167 42.6972 36.9782 42.5878 37.0876C42.4785 37.197 42.417 37.3454 42.417 37.5001V42.1667C42.417 42.3215 42.4785 42.4698 42.5878 42.5792C42.6972 42.6886 42.8456 42.7501 43.0003 42.7501C43.155 42.7501 43.3034 42.6886 43.4128 42.5792C43.5222 42.4698 43.5837 42.3215 43.5837 42.1667V37.5001C43.5837 37.3454 43.5222 37.197 43.4128 37.0876C43.3034 36.9782 43.155 36.9167 43.0003 36.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5837 44.5001C43.5837 44.1779 43.3225 43.9167 43.0003 43.9167C42.6782 43.9167 42.417 44.1779 42.417 44.5001C42.417 44.8223 42.6782 45.0834 43.0003 45.0834C43.3225 45.0834 43.5837 44.8223 43.5837 44.5001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1905_990",
    x1: 37.8613,
    y1: 15.3735,
    x2: 32.5441,
    y2: 22.5109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1905_990",
    x1: 35.1048,
    y1: 11.7646,
    x2: 36.82,
    y2: 26.8865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1905_990",
    x1: 33.7139,
    y1: 7.51097,
    x2: 29.1719,
    y2: 27.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1905_990",
    x1: 29.3724,
    y1: 9.72178,
    x2: 31.694,
    y2: 29.7334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1905_990",
    x1: 22.7952,
    y1: 11.8855,
    x2: 31.5779,
    y2: 32.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1905_990",
    x1: 19.1439,
    y1: 17.8197,
    x2: 25.3211,
    y2: 34.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1905_990",
    x1: 16.7788,
    y1: 21.2386,
    x2: 23.4517,
    y2: 41.4753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1905_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(36 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9116);
export default __webpack_public_path__ + "static/media/Group 9116.738e1605.svg";
export { ForwardRef as ReactComponent };